import {
  Button,
  FlexBox,
  FlexBoxDirection,
  Label,
  ResponsiveGridLayout,
  Title
} from '@ui5/webcomponents-react';
import { env } from 'config/env';
import {
  Exact,
  SupplierInput,
  UpdateUserSupplierMutation,
  useUpdateUserSupplierMutation
} from 'generated/graphql';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { UseMutationState } from 'urql';

interface SwitchRoleItemProps {
  title: string;
  buttonDescription: string;
  lsp?: SupplierInput;
  onClick: () => void;
}

const SwitchRoleItem: React.FC<SwitchRoleItemProps> = ({
  lsp,
  title,
  buttonDescription,
  onClick
}) => {
  return (
    <FlexBox
      direction={FlexBoxDirection.Column}
      style={{
        border: 'var(--_ui5_card_border)',
        boxShadow: 'var(--_ui5_card_box_shadow)',
        borderRadius: 'var(--_ui5_card_border-radius)',
        padding: '1rem'
      }}
    >
      <Title level="H3" style={{ flex: 'auto' }}>
        {title}
      </Title>
      <Label>
        <pre>{lsp ? JSON.stringify(lsp, undefined, 2) : null}</pre>
      </Label>
      <br />
      <Button onClick={onClick}>{buttonDescription}</Button>
      <br />
    </FlexBox>
  );
};
interface SwitchRoleResponseProps {
  data: UseMutationState<
    UpdateUserSupplierMutation,
    Exact<{
      input: SupplierInput | SupplierInput[];
    }>
  >;
}
const SwitchRoleResponse = ({ data }: SwitchRoleResponseProps) => {
  return (
    <>
      {data.fetching ? <p>Loading...</p> : null}
      {!data.fetching && data.error ? (
        <p>
          Error updating : <pre>{JSON.stringify(data.error, undefined, 4)}</pre>
        </p>
      ) : null}
      {!data.fetching && data.data?.updateUserSupplier ? (
        <p>
          Updated successfully:
          <pre>{JSON.stringify(data.data.updateUserSupplier, undefined, 4)}</pre>
        </p>
      ) : null}
    </>
  );
};

const getSuppliers = (): SupplierInput[] => {
  const suppliersJsonString = env?.REACT_APP_UPDATE_SUPPLIERS_JSON;
  try {
    return suppliersJsonString ? JSON.parse(suppliersJsonString) : [];
  } catch (error) {
    console.error(error);
  }
  return [];
};

const isEnabled = () => {
  return env?.REACT_APP_REACT_ENABLE_UPDATE_SUPPLIER === 'true';
};

export const SwitchRoles = () => {
  const [data, updateUserSupplier] = useUpdateUserSupplierMutation();
  const history = useHistory();
  const suppliers: SupplierInput[] = getSuppliers();

  if (!isEnabled()) {
    history.replace('/queries');
  }

  return (
    <div style={{ padding: '0 5rem' }}>
      <br />
      <Title>SwitchRoles</Title>
      <br />
      <ResponsiveGridLayout columnsXL={5} columnsL={3} columnsM={2} columnsS={1}>
        <SwitchRoleItem
          title="Revert"
          buttonDescription="Revert to original"
          onClick={() =>
            updateUserSupplier({
              input: [],
              internal: false
            })
          }
        />
        <SwitchRoleItem
          title="Internal"
          buttonDescription="Change to Internal"
          onClick={() =>
            updateUserSupplier({
              input: [],
              internal: true
            })
          }
        />
        {suppliers.map((lsp: SupplierInput) => (
          <SwitchRoleItem
            key={lsp.vendor}
            title={lsp.name}
            buttonDescription={`Switch to ${lsp.name}`}
            lsp={lsp}
            onClick={() =>
              updateUserSupplier({
                input: [lsp],
                internal: false
              })
            }
          />
        ))}
      </ResponsiveGridLayout>
      <SwitchRoleResponse data={data} />
    </div>
  );
};
